var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewOrganization = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M18.0047,20.0047 L2.0047,20.0047 C0.8977,20.0047 -0.0003,19.1077 -0.0003,17.9997 L-0.0003,2.0097 C-0.0003,0.9017 0.8977,0.0047 2.0047,0.0047 L17.9997,-0.0003 C19.1077,-0.0003 20.0047,0.8977 20.0047,2.0047 L20.0097,17.9997 C20.0097,19.1077 19.1117,20.0047 18.0047,20.0047 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.0047,9.0047 L11.0047,9.0047 L11.0047,6.0047 C11.0047,5.4517 10.5577,5.0047 10.0047,5.0047 C9.4517,5.0047 9.0047,5.4517 9.0047,6.0047 L9.0047,9.0047 L6.0047,9.0047 C5.4517,9.0047 5.0047,9.4517 5.0047,10.0047 C5.0047,10.5577 5.4517,11.0047 6.0047,11.0047 L9.0047,11.0047 L9.0047,14.0047 C9.0047,14.5577 9.4517,15.0047 10.0047,15.0047 C10.5577,15.0047 11.0047,14.5577 11.0047,14.0047 L11.0047,11.0047 L14.0047,11.0047 C14.5577,11.0047 15.0047,10.5577 15.0047,10.0047 C15.0047,9.4517 14.5577,9.0047 14.0047,9.0047"
}))));
export default SvgNewOrganization;